import { IElementType } from "@faro-lotv/ielement-types";
import { clearStore } from "@faro-lotv/project-source";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { fetchProjectIElements } from "@store/i-elements/i-elements-slice-thunk";

/**
 * SdbIElementsState is an extra store state that expands the IElementsState.
 */
interface SdbIElementsState {
  hasFetchedPointCloudsIElements: boolean;
  hasFetchedMarkupsIElements: boolean;
}

const initialState: SdbIElementsState = Object.freeze({
  hasFetchedPointCloudsIElements: false,
  hasFetchedMarkupsIElements: false,
});

const sdbIElementsSlice = createSlice({
  name: "sdbIElements",
  initialState,
  reducers: {
    setHasFetchedPointCloudsIElements(state, action: PayloadAction<boolean>) {
      state.hasFetchedPointCloudsIElements = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(fetchProjectIElements.fulfilled, (state, action) => {
        if (action.meta.arg.types?.includes(IElementType.markup)) {
          state.hasFetchedMarkupsIElements = true;
        }
      })
      // Use the clearStore action from the lotv package so that upon calling clearStore it wil
      // clear both the IElementsState and the SdbIElementsState
      .addCase(clearStore, () => initialState);
  },
});

export const {
  setHasFetchedPointCloudsIElements,
} = sdbIElementsSlice.actions;

export const sdbIElementsReducer = sdbIElementsSlice.reducer;
